import type { Booking } from '@/types/domain/bookings';
import { bookingsRequestService } from '@/api/bookings';

export const bookingsGet = () => bookingsRequestService<Booking[]>({
    url: '/bookings',
    method: 'GET'
});
